import { Injectable } from '@angular/core';
import { TabSession } from './tab-session';

@Injectable({
  providedIn: 'root'
})
export class TabSessionStorageService {

  tabSession: TabSession;

  constructor() { }

  removeTabFromSession(tab) {
    const tabs = this.tabSession.tabs;
    const tabIndex = tabs.findIndex((t) => t.id === tab.id);
    if (tabIndex > -1) {
      const removedTab = tabs.splice(tabIndex, 1)[0];
      return removedTab;
    } else {
      throw new Error("Trying to remove tab that is not is session");
    }
  }
}
